export interface MegaMenuDropdownItem {
  name: string;
  description?: string;
  url: string;
  icon?: string;
}

export interface SimpleDropdownItem {
  name: string;
  url: string;
}

export type DropdownItem = MegaMenuDropdownItem | SimpleDropdownItem;

export function hasIcon(item: DropdownItem): item is MegaMenuDropdownItem {
  return 'icon' in item && item.icon !== undefined;
}

export function hasDescription(
  item: DropdownItem
): item is MegaMenuDropdownItem {
  return 'description' in item && item.description !== undefined;
}

export interface MegaMenuDropdownColumn {
  title: string;
  url?: string;
  isLinkableTitle?: boolean;
  titleIcon?: string;
  // placement controls layout within a dropdown; default is column
  placement?: 'bottom' | 'column';
  items: MegaMenuDropdownItem[];
}

export interface MegaMenuDropdownProps {
  config: MegaMenuDropdownColumn[];
  className?: string;
}

export type FCTopNavProps = Record<string, never>;
